// extracted by mini-css-extract-plugin
export default {"myWrap":"EditCarousel_myWrap__Y7lY-"};